import React from "react";
import { LegalLayout } from "../../components/LegalLayout";

const SECTIONS = [
  {
    heading: "1. Where Atlas data comes from",
    body: [
      "Atlas aggregates and organizes vehicle information from external sources such as automotive marketplaces, dealer websites and public listings across European markets. In this prototype, the data is simulated to demonstrate how Atlas normalizes and analyzes information; it is clearly labelled as prototype data and must not be treated as live market data.",
    ],
  },
  {
    heading: "2. Accuracy and completeness",
    body: [
      "Atlas does not create or control original listings. We make reasonable efforts to normalize and present information and to flag inconsistencies or missing data, but we cannot guarantee that third-party information is complete, accurate, current or free from errors.",
      "You are responsible for independently verifying vehicle condition, documentation, ownership, price, availability, registration, taxes and all other relevant information directly with the seller or original source before completing any transaction.",
    ],
  },
  {
    heading: "3. External-source links",
    body: [
      "Each opportunity links to its original source via \u201cView original listing.\u201d Following that link takes you to a third-party website governed by its own terms and privacy practices. Atlas is not responsible for third-party sites.",
    ],
  },
  {
    heading: "4. Source states and verification",
    body: [
      "Markets are shown as Active (prototype opportunities available), Connector Ready (defined and prepared for future integration, no data yet) or Planned (in Atlas\u2019s European scope, no source yet). Submitted dealer/sources move through Submitted \u2192 Under Review \u2192 Verified \u2192 Active and may be Suspended. A submitted source is not automatically trusted.",
    ],
  },
  {
    heading: "5. Atlas does not transact",
    body: [
      "Atlas does not sell vehicles, process vehicle payments, accept deposits or act as escrow, and will never ask you to send money to secure or purchase a vehicle. Report any such request via Report an Issue.",
    ],
  },
  {
    heading: "6. Reporting inaccurate data",
    body: [
      "If you believe a listing or piece of information is inaccurate, misleading or fraudulent, use the Report an Issue tool. Reports move through Reported \u2192 Under Review \u2192 Corrected, Removed or Rejected.",
    ],
  },
];

export default function LegalDataSources() {
  return (
    <LegalLayout
      testid="legal-data-sources"
      currentPath="/legal/data-sources"
      title="Data & Third-Party Sources"
      intro="How Atlas sources, normalizes and presents vehicle information — and the limits of that data. Draft, pending legal review."
      sections={SECTIONS}
    />
  );
}
